module.exports = __webpack_public_path__ + "img/_SDI9422-1000.3e2b7787.webp";